const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiConfig = {
    baseURL: "https://hel-zeta.vercel.app/v1",

    socketURL:  "https://hel-zeta.vercel.app/"
};

export default apiConfig;
